module.exports = __webpack_public_path__ + "static/media/les-img-2.74b1c510.png";